import { useQuery as useReactQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { fetchStreakData } from "../api";

const useStreakData = () => {
  const { data: streakData } = useReactQuery({
    queryKey: ['streakData'],
    queryFn: () => fetchStreakData()
  });

  const updatedStreakData = useMemo(() => ({
    attendance: (streakData?.attendance_dates ?? []).map(date => ({
      createdAt: date
    })),
    bestStreak: streakData?.longest_ever_streak ?? 0,
    currentStreak: streakData?.streak_length ?? 0
  }), [streakData]);

  return updatedStreakData;
};

export { useStreakData };